import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-allocated.component.ajs.html';

const MODULE_NAME = 'agentBookingMailAllocated';

class AgentBookingMailAllocatedCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailAllocated implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailAllocatedCtrl];
}

export default MODULE_NAME;
